// extracted by mini-css-extract-plugin
export default {"item":"Item_item__z3-U7","counter":"Item_counter__SG+oi","balance":"Item_balance__yNmTS"};